import { NC, LOGO_URL } from "../landing/shared";

const DISCLOSURE =
  "Equal Housing Opportunity. This is not a commitment to lend and not an offer of credit. This replay is educational; watching it or requesting a review does not constitute a loan approval. All loans are subject to a complete application, credit approval, income and asset verification, property eligibility, appraisal, and program guidelines. Nothing here is a quote or a guarantee of eligibility, rate, payment, fees, costs, savings, timing, or closing. VA-backed loan programs are administered by the U.S. Department of Veterans Affairs; Shoreline Mortgage Group is not endorsed by or affiliated with the VA or any government agency. Licensed in Florida and Pennsylvania.";

export default function ReplayFooter() {
  return (
    <footer className="relative overflow-hidden border-t border-white/10 pt-20 pb-28 md:pb-12 px-6 lg:px-10" data-testid="replay-footer-section">
      <div
        aria-hidden="true"
        className="absolute left-1/2 -translate-x-1/2 bottom-0 font-black uppercase select-none pointer-events-none whitespace-nowrap"
        style={{ fontSize: "14vw", color: "rgba(255,255,255,0.03)", lineHeight: 0.85, letterSpacing: "-0.02em" }}
      >
        BETTER-BUY
      </div>
      <div className="relative max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-10 mb-14">
          <div className="space-y-2 text-sm text-white/55">
            <img src={LOGO_URL} alt="Shoreline Mortgage Group" className="h-14 w-auto mb-4 bg-white/90 p-1.5" />
            <p className="font-semibold text-white">Josh Bartlett · Branch Manager</p>
            <p>Shoreline Mortgage Group</p>
            <p>NMLS# 1425493 (client-submitted, pending verification)</p>
            <p>Company NMLS# <NC label="COMPANY NMLS" /></p>
            <p><NC label="LEGAL ENTITY / POWERED-BY WORDING" /></p>
            <p>Licensed in Florida and Pennsylvania</p>
          </div>
          <div className="space-y-2 text-sm text-white/55">
            <p className="font-mono-strict text-[10px] tracking-[0.3em] text-white/35 mb-3">CONTACT</p>
            <p>Phone: <NC label="PHONE" /></p>
            <p>Email: <NC label="EMAIL" /></p>
            <p>
              <a href="https://www.joshbartlettmortgage.com/" target="_blank" rel="noopener noreferrer" className="text-[#0162CA] hover:underline" data-testid="replay-footer-website-link">
                joshbartlettmortgage.com
              </a>
            </p>
            <p>Branch address: <NC label="BRANCH ADDRESS" /></p>
          </div>
          <div className="space-y-2 text-sm text-white/55">
            <p className="font-mono-strict text-[10px] tracking-[0.3em] text-white/35 mb-3">LEGAL</p>
            <p><a href="/privacy" className="text-[#0162CA] hover:underline" data-testid="replay-footer-privacy-link">Privacy Policy</a></p>
            <p><a href="/terms" className="text-[#0162CA] hover:underline" data-testid="replay-footer-terms-link">Terms of Use</a></p>
            <p><a href="#disclaimer" className="hover:text-white/80">Disclaimer</a></p>
            <p>
              <a href="https://www.nmlsconsumeraccess.org/" target="_blank" rel="noopener noreferrer" className="text-[#0162CA] hover:underline" data-testid="replay-footer-nmls-link">
                NMLS Consumer Access
              </a>
            </p>
          </div>
        </div>
        <div className="flex gap-4 items-start border-t border-white/10 pt-8">
          <span className="text-2xl shrink-0" title="Equal Housing Opportunity">⌂</span>
          <p className="text-[11px] leading-relaxed text-white/35 max-w-4xl">{DISCLOSURE}</p>
        </div>
        <p className="font-mono-strict text-[10px] tracking-[0.2em] text-white/20 mt-10">
          © 2026 SHORELINE MORTGAGE GROUP · BETTER-BUY.REPLAY v1.0
        </p>
      </div>
    </footer>
  );
}
